import {
  STUDIO_CATEGORY_QUERY_PARAM,
  STUDIO_PRODUCT_QUERY_PARAM,
} from '@/utils/studio-preview-locale-url';

const PAGINATION_QUERY_PARAMS = ['page', 'sort-by'] as const;

export const STUDIO_PREVIEW_ROUTING_QUERY_PARAMS = [
  STUDIO_PRODUCT_QUERY_PARAM,
  STUDIO_CATEGORY_QUERY_PARAM,
  'locale',
] as const;

export type ProductListingSearchParamsOptions = {
  isStudioPreview?: boolean;
};

export function isPaginationQueryParam(key: string): boolean {
  return (PAGINATION_QUERY_PARAMS as readonly string[]).includes(key);
}

export function isStudioPreviewRoutingQueryParam(key: string): boolean {
  return (STUDIO_PREVIEW_ROUTING_QUERY_PARAMS as readonly string[]).includes(key);
}

export function isProductListingFilterQueryParam(
  key: string,
  options: ProductListingSearchParamsOptions = {},
): boolean {
  if (isPaginationQueryParam(key)) {
    return false;
  }

  if (options.isStudioPreview && isStudioPreviewRoutingQueryParam(key)) {
    return false;
  }

  return true;
}

export function getProductListingAppliedFilters(
  searchParams: Pick<URLSearchParams, 'toString'>,
  options: ProductListingSearchParamsOptions = {},
): URLSearchParams {
  const appliedFilters = new URLSearchParams(searchParams.toString());

  for (const key of PAGINATION_QUERY_PARAMS) {
    appliedFilters.delete(key);
  }

  if (options.isStudioPreview) {
    for (const key of STUDIO_PREVIEW_ROUTING_QUERY_PARAMS) {
      appliedFilters.delete(key);
    }
  }

  return appliedFilters;
}

export function getProductListingFilterEntries(
  searchParams: Pick<URLSearchParams, 'entries' | 'toString'>,
  options: ProductListingSearchParamsOptions = {},
): [string, string][] {
  return Array.from(searchParams.entries()).filter(([key]) =>
    isProductListingFilterQueryParam(key, options),
  );
}

export function clearProductListingFilterParams(
  searchParams: Pick<URLSearchParams, 'toString' | 'keys'>,
  options: ProductListingSearchParamsOptions = {},
): URLSearchParams {
  const result = new URLSearchParams(searchParams.toString());

  Array.from(result.keys()).forEach(key => {
    if (isProductListingFilterQueryParam(key, options)) {
      result.delete(key);
    }
  });

  return result;
}
